'use strict';
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
    return __assign.apply(this, arguments);
  };
exports.__esModule = true;
exports.createPlugin = void 0;
var ui_plugin_1 = require('ui-plugin');
var pluginStore_1 = require('./pluginStore');
function createPlugin(args) {
  var plugin = ui_plugin_1.createPlugin(args);
  var plugs = [];
  return __assign(__assign({}, plugin), {
    plug: function (slotName, component) {
      plugs.push({ slotName: slotName, component: component });
    },
    namedPlug: function (slotName, plugName, component) {
      plugs.push({
        slotName: slotName,
        component: component,
        plugName: plugName,
      });
    },
    register: function () {
      plugin.register();
      plugs.forEach(function (_a) {
        var slotName = _a.slotName,
          component = _a.component,
          plugName = _a.plugName;
        pluginStore_1.registerPlug({
          slotName: slotName,
          pluginName: args.name,
          component: component,
          plugName: plugName,
        });
      });
    },
  });
}
exports.createPlugin = createPlugin;
